<template lang="html">
  <div class="confirm">
    <Overlay
      :withinOverlay="withinOverlay"
      width="x-small"
      :link="link">
      <div class="confirm-inner">
        <p v-if="confirmMessage" v-html="confirmMessage"></p>
        <div class="actions">
          <Btn secondary @click="cancel">Cancel</Btn>
          <Btn primary @click="confirm">Confirm</Btn>
        </div>
      </div>
    </Overlay>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import Overlay from '@/components/Overlay'

export default {
  name: 'Confirm',

  props: {
    message: String,

    link: {
      type: Object,
      description: 'Where should the page go when the overlay has closed?'
    },

    withinOverlay: {
      type: Boolean,
      default: false,
      description: `
        This is when an overlay is inside of another overlay.
        If value is set to true, background will be lighter.
      `
    }
  },

  components: {
    Overlay,
    Btn
  },

  computed: {
    confirmMessage() {
      return this.message ? this.message : 'Are you sure?'
    }
  },

  methods: {
    confirm(value) {
      this.$emit('confirm', value)
    },

    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.confirm
  .inner
    height: auto
    max-width: 650px

  .close-overlay
    display: none

.confirm-inner
  text-align: center
  padding: $gap-x-small 0

  .actions
    display: flex
    justify-content: space-around
    margin: $gap-medium 0 0
</style>
